﻿<template>
    <div class="header">
        <wrapper>
            <div class="header-top app-wrap d-none d-md-flex flex-row justify-content-end align-items-center">
                <b-nav class="header-top-menu d-inline-flex">
                    <template v-if="!isLoggedIn">
                        <b-nav-item href="/login">{{ $t('login') }}</b-nav-item>
                        <b-nav-item href="/registration">{{ $t('createAccount') }}</b-nav-item>
                    </template>
                    <b-nav-item v-for="(link, index) in headerLinks"
                                :key="'Link_' + index"
                                :href="link.url">{{ link.title }}</b-nav-item>
                </b-nav>

                <social-network :links="socialLinks" />

                <language-switcher v-if="showMultiLanguages" />
            </div>

            <nav class="navbar navbar-dark header-top bg-black d-flex d-md-none px-3">
                <b-nav class="header-top-menu d-flex flex-grow-1 me-5 log-link">
                    <b-nav-item v-if="!isLoggedIn" href="/login">{{ $t('login') }}</b-nav-item>
                    <b-nav-item v-else class="bg-black" @click="logOut()">{{ $t('logout') }}</b-nav-item>
                </b-nav>

                <social-network :links="socialLinks" />

                <language-switcher v-if="showMultiLanguages" />
            </nav>

            <nav class="navbar navbar-dark bg-black d-block d-md-none header-bar">
                <div class="d-flex align-items-center">
                    <button class="navbar-toggler"
                            type="button"
                            data-bs-toggle="offcanvas"
                            data-bs-target="#offcanvas"
                            aria-controls="offcanvas"
                            aria-label="menu button mobile">
                        <span class="navbar-toggler-icon"></span>
                    </button>
                    <router-link to="/" class="logo">
                        <img src="/src/assets/logo_mini.svg" width="30" alt="Trimm" loading="lazy" />
                    </router-link>

                    <div class="d-flex d-md-none me-2 ms-auto">
                        <button type="button" class="btn position-relative" @click="goToCart">
                            <svg-icon name="header/card" :ariaLabel="$t('cardMobile')" />
                            <span v-if="totalItems > 0" class="position-absolute translate-middle badge rounded-pill">
                                {{ totalItems }}
                                <span class="visually-hidden">{{ $t('totalItems') }}</span>
                            </span>
                        </button>

                    </div>
                </div>
            </nav>

            <div class="offcanvas offcanvas-start" id="offcanvas" aria-labelledby="offcanvasLabel" data-bs-scroll="true">
                <div class="offcanvas-header d-flex justify-content-end">
                    <button type="button"
                            class="btn-close btn-close-white"
                            data-bs-dismiss="offcanvas"
                            :aria-label="$t('close')"></button>
                </div>
                <div class="offcanvas-body d-flex flex-column">
                    <div class="d-flex">
                        <div class="d-flex align-items-center me-3">
                            <img class="my-account-icon" src="/src/assets/header/my-account.svg" :alt="$t('myAccount')" loading="lazy" />
                        </div>
                        <div class="d-flex flex-column">
                            <span>{{ $t('hello') }} {{ username && `, ${username}` }}!</span>
                            <b-dropdown toggle-class="account-menu-btn"
                                        menu-class="account-menu p-0"
                                        variant="link"
                                        :offset="[0, 0]"
                                        left
                                        no-caret
                                        :aria-label="$t('myAccountdd')"
                                        id="dropdown-account-mobile">
                                <template #button-content>
                                    {{ $t('myAccount') }}
                                    <i class="bi bi-chevron-down"></i>
                                </template>

                                <b-dropdown-text v-if="!isLoggedIn" class="border-width-2">
                                    <div class="d-flex flex-column align-items-center p-4">
                                        <div class="title-underlined pe-5 mb-5">{{ $t('welcomeBack') }}</div>

                                        <b-button variant="primary" class="btn-trimm-wide" pill @click="login">{{ $t('login') }}</b-button>

                                        <span class="account-menu-content-text">{{ $t('dontHaveAccount') }} </span>
                                        <span class="account-menu-content-text"><router-link to="/registration">{{ $t('signUp') }}</router-link></span>
                                    </div>
                                </b-dropdown-text>

                                <b-dropdown-text v-else class="py-2 px-3" data-bs-dismiss="offcanvas">

                                    <b-nav-item to="/profile/edit-account" class="account-icon py-2 text-black">
                                        <span class="ms-5">{{ $t('editAccount') }}</span>
                                    </b-nav-item>

                                    <b-nav-item to="/profile/manage-address" class="address py-2 text-black">
                                        <span class="ms-5">{{ $t('myAddress') }}</span>
                                    </b-nav-item>

                                    <b-nav-item to="/profile/quotation-history" class="qoutes-icon py-2 text-black">
                                        <span class="ms-5">{{ $t('myQuotes') }}</span>
                                    </b-nav-item>

                                    <b-nav-item to="/profile/change-password" class="lock-icon py-2 text-black">
                                        <span class="ms-5">{{ $t('changePassword') }}</span>
                                    </b-nav-item>

                                    <b-dropdown-item-button class="py-1" @click="logOut()">
                                        <span>{{ $t('logout') }}</span>
                                    </b-dropdown-item-button>

                                </b-dropdown-text>
                            </b-dropdown>

                        </div>
                    </div>
                    <hr class="my-4" />

                    <div class="header-menu bg-black">
                        <div class="app-wrap">
                            <b-nav class="d-flex flex-column justify-content-between align-items-start px-3">
                                <b-nav-item to="/" class="header-menu-group-btn" data-bs-dismiss="offcanvas">{{ $t('home') }}</b-nav-item>

                                <b-dropdown v-for="(category, index) in categories"
                                            :key="`cat_mob_${category.id}`"
                                            toggle-class="bottom-menu-btn"
                                            menu-class="bottom-menu py-0 px-5 bg-black"
                                            variant="link"
                                            :offset="[-38, 0]"
                                            left
                                            no-caret
                                            :aria-label="`${category.name}-mobile`"
                                            :id="`dropdown-${index}-mobile`">
                                    <template #button-content>
                                        {{ category.name }}
                                        <i class="bi bi-chevron-down"></i>
                                    </template>

                                    <b-dropdown-text data-bs-dismiss="offcanvas">
                                        <ul :class="['bottom-menu-content-item', {'column-count-2': category && category.sub_categories && category.sub_categories.length > 7 && windowsWidthSize() > 767 }]">
                                            <li v-for="(item, subIndex) in category.sub_categories" :key="`sub_mob_${subIndex}`" href="#" tag="li">
                                                <router-link :to="category.se_name ? `/${category.se_name}/${item.se_name}` : `/${item.se_name}`" class="ps-2 text-white">
                                                    {{ item.name }}
                                                </router-link>
                                            </li>
                                            <li v-if="categories && index === (categories.length - 1)">
                                                <a class="ps-2 text-white" target="_blank" rel="nofollow" href="https://trimminc-my.sharepoint.com/:x:/p/visalakshmi_chemudupati/ER9CIUtKTZxGmYtzsvesNYgB9x7x1g5H9JxR_WmodRWnEQ?rtime=aoBivl-G3Ug">LRMS Modbus Registers Information</a>
                                            </li>
                                        </ul>
                                    </b-dropdown-text>
                                </b-dropdown>

                                <b-nav-item to="/blogs" class="header-menu-group-btn" data-bs-dismiss="offcanvas">{{ $t('blog') }}</b-nav-item>
                            </b-nav>
                        </div>
                    </div>

                    <hr class="my-4" />
                    <div class="d-flex justify-content-center"><social-network :links="socialLinks" /></div>
                    <b-nav class="header-top-menu d-flex justify-content-center my-4">
                        <b-nav-item v-for="(link, index) in headerLinks"
                                    :key="'Link_' + index"
                                    :href="link.url">{{ link.title }}</b-nav-item>
                    </b-nav>
                    <div class="d-flex justify-content-center"><a href="tel:(919)-575-61006">(919)-575-6100</a></div>
                </div>
            </div>

            <div class="header-bar app-wrap w-100 pb-4 pt-sm-4 d-flex flex-row justify-content-center align-items-center">
                <div class="d-none d-md-flex me-3 me-xl-5">
                    <router-link to="/" class="logo"><img src="/src/assets/logo.svg" width="224" height="34" alt="Trimm" loading="lazy" /></router-link>
                </div>

                <div class="w-100 d-block d-md-none px-3">
                    <b-form class="w-100" @submit.prevent="find">
                        <b-input-group class="dropdown-input-custom">
                            <!-- Dropdown Input -->
                            <b-form-input @focus="showCustomInputSelect()"
                                          id="type-search-mobile"
                                          @blur="closeCustomInputSelect()"
                                          @keyup="searchProducts"
                                          :placeholder="$t('search')"
                                          v-model="search" />

                            <!-- Dropdown Menu -->
                            <div :class="['dropdown-content', searchItems && searchItems.length ? 'border' : 'pt-0']"
                                 v-show="optionsShown">
                                <div class="dropdown-item"
                                     @mousedown="selectOption(option)"
                                     v-for="(option, index) in searchItems"
                                     :key="index">
                                    <div class="fw-bold" v-html="highlights(option.name)"></div>
                                    <div class="desc" v-html="highlights(`${(option.short_description || '')}${(option.short_description ? '<b class=mx-2>&middot;</b>' : '')}<b>${option.manufacturer_part_number}</b>`)"></div>
                                </div>

                                <div class="dropdown-item" v-if="searchItems.length > 10" @mousedown="find()">
                                    <b class="text-primary">{{ $t('viewAllResults') }}</b>
                                </div>
                            </div>
                            <b-input-group-append is-text>
                                <i @click="find" class="bi bi-search cursor-pointer"></i>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form>
                </div>

                <div class="d-none d-md-flex flex-fill">
                    <b-form class="w-100" @submit.prevent="find">
                        <b-input-group class="dropdown-input-custom">
                            <!-- Dropdown Input -->
                            <b-form-input @focus="showCustomInputSelect()"
                                          id="type-search"
                                          @blur="closeCustomInputSelect()"
                                          @keyup="searchProducts"
                                          :placeholder="$t('search')"
                                          v-model="search" />

                            <!-- Dropdown Menu -->
                            <div :class="['dropdown-content', searchItems && searchItems.length ? 'border' : 'pt-0']"
                                 v-show="optionsShown">
                                <div class="dropdown-item"
                                     @mousedown="selectOption(option)"
                                     v-for="(option, index) in searchItems"
                                     :key="index">
                                    <div class="fw-bold" v-html="highlights(option.name)"></div>
                                    <div class="desc" v-html="highlights(`${(option.short_description || '')}${(option.short_description ? '<b class=mx-2>&middot;</b>' : '')}<b>${option.manufacturer_part_number}</b>`)"></div>
                                </div>

                                <div class="dropdown-item" v-if="searchItems.length > 10" @mousedown="find()">
                                    <b class="text-primary">{{ $t('viewAllResults') }}</b>
                                </div>
                            </div>
                            <b-input-group-append is-text>
                                <i @click="find" class="bi bi-search cursor-pointer"></i>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form>
                </div>

                <div class="d-none d-md-flex mx-3 mx-xl-5">
                    <div class="d-flex align-items-center me-3">
                        <img src="/src/assets/header/phone.svg" :alt="$t('phone')" class="phone-icon" loading="lazy" />
                    </div>
                    <div class="d-flex flex-column">
                        <span>{{ $t('callUsNow') }}</span>
                        <span><a href="tel:(919)-575-6100">(919)-575-6100</a></span>
                    </div>
                </div>

                <div class="d-none d-md-flex">
                    <div class="d-flex align-items-center me-3">
                        <img class="my-account-icon" src="/src/assets/header/my-account.svg" :alt="$t('account')" loading="lazy" />
                    </div>
                    <div class="d-flex flex-column">
                        <span>{{ $t('hello') }}</span>
                        <b-dropdown toggle-class="account-menu-btn"
                                    menu-class="account-menu px-4"
                                    variant="link"
                                    :offset="[43, 25]"
                                    right
                                    no-caret
                                    id="dropdown-account">
                            <template #button-content>
                                {{ isLoggedIn ? username : $t('myAccount') }}
                                <i class="bi bi-chevron-down"></i>
                            </template>

                            <b-dropdown-text>
                                <div v-if="isLoggedIn" class="d-flex flex-column pb-4 pt-3">

                                    <b-nav-item to="/profile/edit-account" class="account-icon py-2 text-black">
                                        <span class="ms-5">{{ $t('editAccount') }}</span>
                                    </b-nav-item>

                                    <b-nav-item to="/profile/manage-address" class="address py-2 text-black">
                                        <span class="ms-5">{{ $t('myAddress') }}</span>
                                    </b-nav-item>

                                    <b-nav-item to="/profile/quotation-history" class="qoutes-icon py-2 text-black">
                                        <span class="ms-5">{{ $t('myQuotes') }}</span>
                                    </b-nav-item>

                                    <b-nav-item to="/profile/change-password" class="lock-icon py-2 text-black">
                                        <span class="ms-5">{{ $t('changePassword') }}</span>
                                    </b-nav-item>

                                    <b-button variant="outline-primary" class="btn-trimm-wide mt-3 trimm-white" pill @click="logOut()">{{ $t('logout') }}</b-button>
                                </div>
                                <div v-else class="d-flex flex-column py-4">
                                    <b-button variant="primary" class="btn-trimm-wide" pill @click="login">{{ $t('login') }}</b-button>
                                    <span class="account-menu-content-text">{{ $t('dontHaveAccount') }} <router-link to="/registration">{{ $t('signUp') }}</router-link></span>
                                </div>
                            </b-dropdown-text>
                        </b-dropdown>
                    </div>
                </div>

                <div class="d-none d-md-flex ms-4 me-2">
                    <button type="button" class="btn position-relative p-0 seo-card" @click="goToCart">
                        <svg-icon name="header/card" :ariaLabel="$t('card')" />
                        <span v-if="totalItems > 0" class="position-absolute translate-middle badge rounded-pill">
                            {{ totalItems }}
                            <span class="visually-hidden">{{ $t('totalItems') }}</span>
                        </span>
                    </button>
                </div>
            </div>
        </wrapper>

        <div class="header-menu d-none d-md-flex">
            <wrapper>
                <div class="app-wrap">
                    <b-nav class="d-flex flex-row justify-content-between align-items-center">
                        <b-nav-item to="/"> {{ $t('home') }} </b-nav-item>
                        <b-nav-item class="m-0" v-for="(category, inx) in categories">
                            <b-dropdown :key="`cat_${inx}`"
                                        @mouseover="category.hover = true"
                                        @mouseleave="category.hover = false"
                                        toggle-class="bottom-menu-btn bi bi-chevron-down"
                                        split
                                        split-class="py-0 px-0"
                                        :menu-class="['bottom-menu', {'show': category.hover }]"
                                        variant="link"
                                        :offset="[-38, 0]"
                                        :aria-label="category.name"
                                        left
                                        :id="`dropdown-${inx}`">
                                <template #button-content>
                                    <router-link :to="category.se_name ? `/${category.se_name}` : '#'">
                                        {{ category.name }}
                                    </router-link>
                                </template>

                                <b-dropdown-text>
                                    <ul :class="['bottom-menu-content-item', {'column-count-2': category && category.sub_categories && category.sub_categories.length > 7 && windowsWidthSize() > 767 }]">
                                        <li v-for="(item, subIndex) in category.sub_categories" :key="`sub_${subIndex}`"href="#" tag="li">
                                            <router-link :to="category.se_name ? `/${category.se_name}/${item.se_name}` : `/${item.se_name}`">
                                                {{ item.name }}
                                            </router-link>
                                        </li>
                                        <li v-if="categories && inx === (categories.length - 1)">
                                            <a target="_blank" rel="nofollow" href="https://trimminc-my.sharepoint.com/:x:/p/visalakshmi_chemudupati/ER9CIUtKTZxGmYtzsvesNYgB9x7x1g5H9JxR_WmodRWnEQ?rtime=aoBivl-G3Ug">LRMS Modbus Registers Information</a>
                                        </li>
                                    </ul>
                                </b-dropdown-text>
                            </b-dropdown>
                        </b-nav-item>
                        <b-nav-item to="/blogs" class="header-menu-group-btn">{{ $t('blog') }}</b-nav-item>
                    </b-nav>
                </div>
            </wrapper>
        </div>
    </div>
</template>

<script>
    import Wrapper from "@/components/common/wrapper.vue";
    import SocialNetwork from "@/components/common/buttons/social-network.vue";
    import SvgIcon from '@/components/common/buttons/svg-icon.vue';
    import LanguageSwitcher from '@/components/common/buttons/language-switcher.vue';
    import { catalogService, wishlistService } from "@/services";
    import { useUserStore } from "@/stores/user";
    import ProductUtils from "@/utils/product-utils";
    import seoMixin from "@/mixins/seo-mixin";
    import 'bootstrap-icons/font/bootstrap-icons.css';
    import { HomePageLinkType } from "@/constants/home-page-link-type-constant";

    export default {
        name: "main-header",

        setup: () => {
            const userStore = useUserStore();
            return { userStore };
        },

        mixins: [seoMixin],

        data: () => ({
            username: "",
            categories: [],
            showMultiLanguages: false,
            //Custom quick search logic
            searchItems: [],
            search: "",
            optionsShown: false,

            totalItems: 0,

            links: []
        }),

        components: {
            wrapper: Wrapper,
            "social-network": SocialNetwork,
            "svg-icon": SvgIcon,
            "language-switcher": LanguageSwitcher
        },

        computed: {
            isLoggedIn() {
                return this.userStore.isAuthenticated;
            },

            socialLinks() {
                return this.links.filter(l => l.home_page_link_type_id === HomePageLinkType.SocialMediaLink);
            },

            headerLinks() {
                return this.links.filter(l => l.home_page_link_type_id === HomePageLinkType.Header);
            }
        },

        async created() {
            this.categories = await catalogService.getMenuLinks();
        },

        methods: {
            login() {
                this.$router.push("/login");
            },

            goToCart() {
                this.$router.push("/quote");
            },

            find() {
                this.$router.push({ path: "/search", query: { term: this.search } });
            },

            goTo(url) {
                this.$router.push(url);
            },

            async logOut() {
                await this.$auth.logout();
                await this.$root.changeLang('en');
                this.username = '';
            },

            //Custom quick search logic
            selectOption(option) {
                this.search = '';
                this.searchItems = [];
                this.$router.push(option.product_url);
            },

            showCustomInputSelect() {
                this.optionsShown = true;
            },

            closeCustomInputSelect() {
                this.optionsShown = false;
            },

            highlights(source) {
                return ProductUtils.highlights(source, this.search);
            },

            async searchProducts() {
                //We start to search only with search word more than 3 symbols
                this.searchItems = this.search && this.search.length > 3
                    ? await catalogService.quickSearchProduct(this.search) : [];
            }
        },

        async mounted() {
            let response = await wishlistService.getHeaderLinks();

            this.totalItems = response.wishlist_items;
            this.username = response.customer_name;
            this.links = response.links;
            this.showMultiLanguages = response.show_multi_languages;

            this.emitter.on("updateHeaderLinks", (data) => {
                this.totalItems = data.wishlist_items;
                this.username = data.customer_name;
            });

            this.emitter.emit('showCookieLaw', response.show_cookie_law);
            this.emitter.emit('setFooterLinks', response);
        },
    };
</script>

<style lang="scss" scoped>
    .dropdown-input-custom {
        position: relative;

        .form-control {
            &:hover, &:focus {
                box-shadow: none;
                border: 1px solid #D9D9D9;
            }
        }

        .dropdown-content {
            position: absolute;
            background-color: #fff;
            width: calc(100% - 1px);
            border-radius: 0.938rem !important;
            border-top-left-radius: 0 !important;
            border-top-right-radius: 0 !important;
            overflow: hidden;
            z-index: 3;
            margin: 18px 0 0 1px !important;
            padding-top: 24px;

            .dropdown-item {
                color: black;
                font-size: .8em;
                padding: 8px;
                text-decoration: none;
                display: block;
                cursor: pointer;

                div {
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }

                .desc {
                    color: gray;
                    font-size: .75em;
                    padding-top: 5px;
                }

                &:hover {
                    background-color: #e7ecf5;
                }
            }
        }

        .input-group-text {
            z-index: 3;
        }
    }
</style>